import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import UserService from '../../services/UserService';
import Vue from 'vue';

@Module({ namespaced: true })
class User extends VuexModule {
    expoDeviceToken = "";
    // Atualização do dispositivo para receber notificações
    @Mutation
    device() {
        const onReceiveMessage = (nativeEvent: MessageEvent) => {
            let nativeMessage;
            try {
                nativeMessage = JSON.parse(JSON.stringify(nativeEvent?.data));
                switch (nativeMessage?.type) {
                    case "expoDeviceToken":
                        this.expoDeviceToken = nativeMessage?.data?.deviceToken;
                        break;
                    default:
                        break;
                }
            } catch (err) {
                // alert(err + " - " + JSON.stringify(nativeEvent?.data));
                return;
            }
        }

        window.addEventListener('message', onReceiveMessage);
        window?.ReactNativeWebView?.postMessage(JSON.stringify({ data: {}, type: "getDeviceToken" }));
    }

    @Mutation
    async registerDevice(user?: any) {
        if (!this.expoDeviceToken) return;

        if (Vue.$cookies.get('expoDeviceToken') !== this.expoDeviceToken) {
            UserService.deviceInfoUpdate({ expoDeviceToken: this.expoDeviceToken }).then(
                resp => {
                    if (resp) {
                        Vue.$cookies.set('expoDeviceToken', this.expoDeviceToken);
                    }
                }
            )
        }

        window?.ReactNativeWebView?.postMessage(JSON.stringify({ data: user, type: "setUser" }));
    }

    @Mutation
    removeDevice() {
        if (!this.expoDeviceToken) return;

        UserService.removeDeviceToken({ expoDeviceToken: this.expoDeviceToken });

        Vue.$cookies.remove('expoDeviceToken');

        window?.ReactNativeWebView?.postMessage(JSON.stringify({ data: {}, type: "removeUser" }));
    }
}
export default User;